(function bingTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};
  global.uetq = global.uetq || [];
  const configurations = {};

  const previousModule = global.NewHomeSource.Analytics.BingTracker;

  /**
   * @private
   * conversionBingYahoo: track event to bing yahoo object.
   *
   */
  function conversionBingYahoo() {
    global.uetq.push({ ec: 'submit' });
  }

  function BingTracker(globalValues) {
    configurations.globalValues = globalValues;
  }

  BingTracker.onDemandTracker = function () {
    if (this.isDirectLead && !this.isFromEuropeanCountry) {
      conversionBingYahoo();
    }

    return true;
  };

  /**
   * @public
   * onDemandTrackerValidator: validates if this track need to be fired.
   *
   * @param {string} data with the specific event type.
   * @returns true if the eventType is a BingEvent
   */
  BingTracker.onDemandTrackerValidator = function (data) {
    return data && data.eventType === 'BingEvent';
  };

  /**
   * @public
   * noConflict: Returns control of NewHomeSource.Analytics.BingTracker to the previous script.
   */
  BingTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.BingTracker = previousModule;
    return BingTracker;
  };

  global.NewHomeSource.Analytics.BingTracker = BingTracker;

  return BingTracker;
}(window));
